import { MechanicValidator } from './MechanicValidator.ts';
import { MechanicValidatorKnight } from './MechanicValidatorKnight.ts';
export class MechanicValidatorKnightActions extends MechanicValidator {
    canPlayerTakeKnightAction(player) {
        const knightLocationsEligibleForActions = this.getAllKnightLocationsEligibleForActions(player);
        if (knightLocationsEligibleForActions.length <= 0) return {
            canTakeAction: false,
            errorMessageIfCantTakeAction: {
                key: 'strings:game.errors.noKnightsForAction'
            },
            validHoverLocations: knightLocationsEligibleForActions
        };
        return {
            canTakeAction: true,
            validHoverLocations: knightLocationsEligibleForActions
        };
    }
    getAllKnightLocationsEligibleForActions(player) {
        const knightsThatPlayerCanMove = this.getKnightLocationsPlayerCanMove(player);
        const knightsThatCanDisplaceTheRobberOrPirate = this.getKnightLocationsThatCanChaseAwayTheRobberOrPirate(player);
        return [
            ...knightsThatPlayerCanMove,
            ...knightsThatCanDisplaceTheRobberOrPirate
        ];
    }
    getKnightLocationsPlayerCanMove(player) {
        const knightPlayerValidator = this.knightValidator.getKnightPlayerValidator(player);
        const knightLocationsThatCanBeMoved = [];
        for (const knight of knightPlayerValidator.getKnightStates()){
            if (!knight.isActivated) continue;
            if (knight.locationCornerIndex == undefined) continue;
            if (knight.isActivatedThisTurn) continue;
            const includeKnightDisplacement = true;
            const whereCanPlayerMoveKnight = this.knightValidator.whereCanPlayerMoveKnight(knight, player, includeKnightDisplacement);
            const doesPlayerHaveSomewhereToMoveKnight = whereCanPlayerMoveKnight.length > 0;
            if (!doesPlayerHaveSomewhereToMoveKnight) continue;
            knightLocationsThatCanBeMoved.push(knight.locationCornerIndex);
        }
        return knightLocationsThatCanBeMoved;
    }
    getKnightLocationsThatCanChaseAwayTheRobberOrPirate(player) {
        const knightPlayerValidator = this.knightValidator.getKnightPlayerValidator(player);
        const knightsThatCanChaseAwayTheRobber = [];
        for (const knight of knightPlayerValidator.getKnightStates()){
            if (!knight.isActivated) continue;
            if (knight.locationCornerIndex == undefined) continue;
            if (knight.isActivatedThisTurn) continue;
            const whereCanKnightChaseAwayRobberOrPirate = this.whereCanKnightChaseAwayRobberOrPirate(knight);
            if (whereCanKnightChaseAwayRobberOrPirate.length <= 0) continue;
            knightsThatCanChaseAwayTheRobber.push(knight.locationCornerIndex);
        }
        return knightsThatCanChaseAwayTheRobber;
    }
    whereCanKnightChaseAwayRobberOrPirate(knightState) {
        if (knightState.locationCornerIndex == undefined) return [];
        const tileCorner = this.mapValidator.tileState.tileCorners[knightState.locationCornerIndex];
        const whereCanPlayerChaseAwayRobberOrPirate = [];
        for (const touchingFace of tileCorner.hexCorner.touchingFaces()){
            var _this_robberState, _this_robberState1, _this_pirateState, _this_pirateState1;
            const tileHex = this.mapValidator.tileState.getTileHex(touchingFace);
            if (tileHex == undefined) continue;
            const tileIndex = this.mapValidator.tileState.getTileHexIndex(tileHex.hexFace);
            if (tileIndex == undefined) continue;
            if (((_this_robberState = this.robberState) === null || _this_robberState === void 0 ? void 0 : _this_robberState.isActive) == true && ((_this_robberState1 = this.robberState) === null || _this_robberState1 === void 0 ? void 0 : _this_robberState1.locationTileIndex) == tileIndex) whereCanPlayerChaseAwayRobberOrPirate.push(tileIndex);
            if (((_this_pirateState = this.pirateState) === null || _this_pirateState === void 0 ? void 0 : _this_pirateState.isActive) == true && ((_this_pirateState1 = this.pirateState) === null || _this_pirateState1 === void 0 ? void 0 : _this_pirateState1.locationTileIndex) == tileIndex) whereCanPlayerChaseAwayRobberOrPirate.push(tileIndex);
        }
        return whereCanPlayerChaseAwayRobberOrPirate;
    }
    constructor(playerValidators, mapValidator, knightState, robberState, pirateState){
        super(playerValidators, mapValidator);
        this.knightValidator = new MechanicValidatorKnight(playerValidators, mapValidator, knightState);
        this.robberState = robberState;
        this.pirateState = pirateState;
    }
}
